require('vendor/assets/components/jquery-validation/dist/additional-methods.min.js')
Feedbacks = LP.module 'Feedbacks'
Analytics = LP.module 'Analytics'

Feedbacks.site = ->
  if $('#feedback_popup').length isnt 0
    # show modal if js hook exists
    $('a.js-testimonial-popup').on('click.feedback_popup', -> $('#feedback_popup').modal())

    # auto show modal for some controllers
    if $('body').data('controller') in ['searches', 'articles']
      $('#feedback_popup').modal()

  $('#feedback_popup').on 'shown.bs.modal', ->
    Analytics.track 'Asked to Testify'
    Analytics.trackForm 'new_feedback', 'Testified'

    $.post LP.config.solicited_feedbacks_path if LP.config.solicited_feedbacks_path
    $('a.js-testimonial-popup').off('click.feedback_popup')

  $('body').on 'click', '#feedback-form-submit', (e) ->
    Analytics.trackForm 'feedback-form', 'Submitted Feedback'

  $('span.see-more').on 'click', (e)->
    el = $(e)[0].currentTarget
    complete = $(el)[0].previousElementSibling
    teaser = $(complete)[0].previousElementSibling
    if $(el)[0].innerText.indexOf('more') >= 0
      $(el).text('See less')
      $(teaser).toggle()
    else
      $(el).text('See more')
      $(teaser).toggle()
    $(complete).toggle()

  $("#new_feedback").validate({
    rules: {
      "feedback_how_lp_helps": {
        require_from_group: [1, ".one-field-required"]
      },
      "feedback_improvement_ideas": {
        require_from_group: [1, ".one-field-required"]
      }
    },
    submitHandler: Feedbacks.submit
  })

Feedbacks.new = ->
  Analytics.track 'Asked to Testify'
  Analytics.trackForm 'new_feedback', 'Testified'

Feedbacks.submit = (form, e) ->
  doubleSubmitHandler(form)
